import { Injectable } from "@angular/core";

import {
  OrdersTableDefinitionFactory,
  ActiveUserProfilePromiseService,
  ClientPromiseLookupService,
  CcyPairPromiseLookupService,
  CurrencyPairGroupPromiseLookupService,
  AlgoStrategyLookupService,
  AlgoStrategyPromiseLookupService,
} from "shared/cubiq-services";
import { BfxOrderBlotterFilteringService } from "../../bfx-blotter-orders/bfx-blotter-orders-filter.service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxSysConfigUtilService } from "shared/auth-services";
import { COLUMN_LADDER_TEMPERATURE_VALUE } from "../../../shared/cubiq-services/model/OrdersTableDefinitionFactory.constants";

@Injectable()
export class BfxOrderLadderFilteringService extends BfxOrderBlotterFilteringService {
  constructor(
    protected tableDefinitionFactory: OrdersTableDefinitionFactory,
    protected activeUserService: ActiveUserProfilePromiseService,
    protected clientService: ClientPromiseLookupService,
    protected currencyPairService: CcyPairPromiseLookupService,
    protected currencyPairGroupService: CurrencyPairGroupPromiseLookupService,
    protected algoStrategyLookup: AlgoStrategyPromiseLookupService,
    protected sysConfigUtilService: BfxSysConfigUtilService,
  ) {
    super(
      tableDefinitionFactory,
      activeUserService,
      clientService,
      currencyPairService,
      currencyPairGroupService,
      algoStrategyLookup,
      sysConfigUtilService,
    );
  }

  protected getRowTemperature(rowData: any, dealtMode?: boolean): number {
    let value = rowData[COLUMN_LADDER_TEMPERATURE_VALUE];
    if (value == undefined) {
      value = 0;
    }
    return value;
  }
}
